import { useEffect, useState } from 'react'
import RequestBreadcrumb from '../../common/RequestBreadcrumb'
import FeeForm from './FeeForm'
import BasicDetailsCard from '../BasicDetails/common/BasicDetailsCard'
import SimpleSpinner from '../../loader'

const index = () => {
    const [isEdit, setIsEdit] = useState(false)
    const [dataLoading, setDataLoading] = useState(true);
    const [basicDetailsData, setBasicDetailsData] = useState(true)
    const [feeFormData, setFeeFormData] = useState(true)

    useEffect(() => {
        if (!feeFormData && !basicDetailsData) {
            setDataLoading(false)
        }
    }, [feeFormData, basicDetailsData])

    return (
        <>
            <div
                className='basic_details fees_and_commissions_container'
            >
                <div className="basic_detail_breadcrumb">
                    <RequestBreadcrumb
                        firstName="Dashboard"
                        link="/"
                        currentStep="Fees and Commissions"
                    />
                </div>
                {!isEdit && (
                    <div className="organization_card_container">
                        <BasicDetailsCard
                            basicDetailsData={basicDetailsData}
                            setBasicDetailsData={setBasicDetailsData}
                        />
                    </div>
                )}
                <div className='d-flex align-items-center justify-content-between px-4'>
                    <h3 className='main_heading fw-bold black'>Fees and Commissions</h3>
                    {!isEdit && (
                        <p className='normal_text blue clickable' onClick={() => setIsEdit(true)}>
                            Edit Details
                        </p>
                    )}
                </div>
                <div className='h-100 w-100 justify-content-center align-items-center' style={{ display: dataLoading ? "block" : "none", marginTop: "80px" }}>
                    <SimpleSpinner />
                </div>
                <div className='basic_details_container pt-0' style={{ height: !isEdit ? "calc(100vh - 230px)" : "", display: !dataLoading ? "block" : "none" }}>
                    <FeeForm
                        feeFormData={feeFormData}
                        setFeeFormData={setFeeFormData}
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                    />
                </div>
            </div>
        </>
    )
}

export default index